import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'

const CloudSettings = () => {
  return (
    <Suspense fallback={<div />}>
      <Outlet />
    </Suspense>
  )
}

export default CloudSettings
